<ix-modal-header>
  {{ 'battery_pass.list.create_children' | translate }}
</ix-modal-header>
<ix-modal-content>
  <ix-typography>
    {{ 'battery_pass.list.how_many_children' | translate }}
  </ix-typography>
  <ix-number-input
    id="inputValue"
    class="number-input py-2"
    [ngClass]="isNumberOfPassportsValid() ? 'ix-valid' : 'ix-invalid'"
    #numberOfChildrenToBeCreated
    [value]="numberOfPassports"
    [min]="minNumberOfPassports"
    [max]="maxNumberOfPassports"
    label="{{ 'battery_pass.list.number_of_passports' | translate }}"
    [(value)]="numberOfPassports"
    show-stepper-buttons
    (valueChange)="onNumberOfPassportsChange()"
    invalidText="{{ 'battery_pass.list.input_limits' | translate }}"
  ></ix-number-input>
</ix-modal-content>
<ix-modal-footer>
  <ix-button
    class="dismiss-modal"
    id="workflowModalCancel"
    (click)="activeModal.dismiss('dismiss')"
    onkeypress=""
    variant="secondary"
  >
    {{
      isTemplateCreationInProgress
        ? ('general.skip' | translate)
        : ('general.cancel' | translate)
    }}
  </ix-button>
  <ix-button
    id="addIndividualButton"
    (click)="onAddIndividualPassportClick()"
    [disabled]="!isNumberOfPassportsValid()"
    onkeypress=""
    variant="primary"
  >
    {{ 'general.add' | translate }}
  </ix-button>
</ix-modal-footer>
